import App from '../app.js'
import Vue from 'vue'
import '../styles/app.css'
import GLightbox from 'glightbox'
import 'glightbox/dist/css/glightbox.css'

new Vue({
  extends: App,
  mounted () {
    GLightbox({ selector: '.glightbox' })
  }
})
